export const toast = (text)=>{
  if(global.vm) {
    global.vm.$Message.info(text);
  }

}

/** 加载中 */
export const showLoading = ()=>{
  if(global.vm) {
    global.vm.$Spin.show({
      render: (h) => {
        return h('div', [
          h('Icon', {
            'class': 'demo-spin-icon-load',
            props: {
              type: 'load-c',
              size: 26
            }
          }),
          h('div', '加载中')
        ])
      }
    });
  }
}

/** 关闭加载页面 */
export const dismissLoading = ()=>{
  if(global.vm) {
    global.vm.$Spin.hide();
  }
}



// WEBPACK FOOTER //
// ./src/libs/LoadingUtil.js